var map = {
	"./_dragndrop/index": [
		241,
		0,
		6,
		1,
		8,
		10
	],
	"./flashcards/index": [
		236,
		0,
		9,
		1,
		11
	],
	"./hotspot/index": [
		240,
		0,
		2,
		1,
		7,
		12
	],
	"./imagemap/index": [
		242,
		0,
		1,
		7,
		13
	],
	"./labeling/index": [
		239,
		0,
		2,
		6,
		1,
		8,
		14
	],
	"./matching/index": [
		238,
		0,
		2,
		1,
		16
	],
	"./slideshow/index": [
		235,
		0,
		2,
		9,
		1,
		18
	],
	"./timeline/index": [
		237,
		0,
		1,
		19
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 232;
module.exports = webpackAsyncContext;